"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MergeStylesDefaultContext = exports.getNewContext = void 0;
var merge_styles_1 = require("@fluentui/merge-styles");
var React = require("react");
var noop = function () { return false; };
var noopShadow = function () { return merge_styles_1.DEFAULT_SHADOW_CONFIG; };
var noopRootStylesheets = function () { return new Map(); };
var noopUndefined = function () { return undefined; };
var getNewContext = function () {
    return {
        stylesheets: new Map(),
        useAdoptedStylesheetEx: noop,
        useAdoptedStylesheet: noop,
        useShadowConfig: noopShadow,
        useMergeStylesShadowRootContext: noopUndefined,
        useHasMergeStylesShadowRootContext: noop,
        useMergeStylesRootStylesheets: noopRootStylesheets,
        useWindow: noopUndefined,
        useStyled: noopUndefined,
    };
};
exports.getNewContext = getNewContext;
exports.MergeStylesDefaultContext = React.createContext((0, exports.getNewContext)());
//# sourceMappingURL=MergeStylesDefaultContext.js.map